import { render, staticRenderFns } from "./QuizLayout.vue?vue&type=template&id=5a3e0c4e&"
import script from "./QuizLayout.vue?vue&type=script&lang=js&"
export * from "./QuizLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports